import { h, render } from 'preact';
import { riperStorage } from '@/base/helpers';
import CartButton from './CartButton';

const CartButtonRenderer = {
  _containers: [],
  setContainers() {
    this._containers = [];
    const placeholders = document.getElementsByClassName('beans-cart');
    if (placeholders.length) {
      for (let i = 0; i < placeholders.length; i++) {
        placeholders[i].classList.add('beans-cart-appended');
        this._containers.push({
          target: placeholders[i],
          buttonClass: placeholders[i].getAttribute('beans-btn-class') || '',
          type: CartButton,
        });
      }
    } else {
      const cartFormSelector = [
        "form[action='/cart']",
        "form[action^='/cart?']",
        "form[action='/checkout']",
        "form[action^='/checkout?']",
        "form[action$='cart.php']",
        '[data-cart]',
      ].join(',');
      const fps = document.querySelectorAll(cartFormSelector);
      for (let i = 0; i < fps.length; i++) {
        const c0 = document.createElement('div');
        c0.classList.add('beans-cart');
        c0.classList.add('beans-cart-created');
        let buttonClass = '';
        try {
          buttonClass = fps[i].querySelector(
            "input[name='checkout'], button[name='checkout'], a[href='/checkout']"
          ).className;
        } catch (err) {
          // continue regardless of error
        }
        fps[i].appendChild(c0);
        this._containers.push({
          target: c0,
          buttonClass,
          type: CartButton,
        });
      }
    }
    return this._containers;
  },
  render() {
    this._containers.forEach(function (container) {
      const TagName = container.type;
      container.node = (
        <TagName
          account={riperStorage.account}
          cart={riperStorage.cart}
          coupon={riperStorage.coupon}
          display={riperStorage.riperDisplay}
          onAbout={riperStorage.onAbout}
          buttonClass={container.buttonClass}
        />
      );
      if (container.target.innerHTML.includes('<div')) return;
      container.target.innerHTML = '';
      render(container.node, container.target);
    });
  },
};

export default CartButtonRenderer;
